import React from "react";
import { useTranslation } from "contexts/i18nContext";
import { LoadingIcon } from "utils/constant";

interface ConfirmationModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  isLoading,
  onCancel,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const resolvedTitle = title || t("confirmSubmissionTitle");
  const resolvedMessage = message || t("confirmSubmissionMessage");
  const resolvedConfirmText = confirmText || t("confirm");
  const resolvedCancelText = cancelText || t("cancel");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 mx-4">
        <div className="flex justify-center mb-4">
          <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center text-2xl">
            ✔
          </div>
        </div>
        <h2 className="text-lg font-semibold text-center mb-2">
          {resolvedTitle}
        </h2>
        <p className="text-sm text-gray-600 text-center mb-6">
          {resolvedMessage}
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 transition"
          >
            {resolvedCancelText}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm bg-black text-white rounded-md hover:bg-gray-800 transition"
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                {LoadingIcon}
                {t("submitting")}
              </div>
            ) : (
              resolvedConfirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
